module.exports = __webpack_public_path__ + "img/client18.ae4b7497.svg";